import workImg from "../../../assets/image/visa1.jpg";
import studyImg from "../../../assets/image/visa2.jpg";
import visitImg from "../../../assets/image/visa3.jpg";

import visitImgw from "../../../assets/image/visa4.jpg";
import visitImge from "../../../assets/image/visa5.jpg";
import visitImgs from "../../../assets/image/visa6.jpg";

import workIcon from "../../../assets/image/work-icon.png";
import studyIcon from "../../../assets/image/study-icon.png";
import visitIcon from "../../../assets/image/visit-icon.png";


import tourists from "../../../assets/image/tourists-visa.png";
import migration1 from "../../../assets/image/migration-visas.png";
import migration from "../../../assets/image/business-visa.png";
import visitImge1 from "../../../assets/image/canada1.png";
import studyImg1 from "../../../assets/image/canada2.png";
import visitImgs1 from "../../../assets/image/canada3.png";

import sponsorImg from "../../../assets/image/sponsorImg.png";
import passportIcon from "../../../assets/image/passportIcon.png";
import residenceImg from "../../../assets/image/residenceImg.png";
import residenceIcon from "../../../assets/image/residenceIcon.png";


import visitImgwd from "../../../assets/image/hiihtu.png"


import { Link } from "react-router-dom";
import { IoIosArrowRoundForward } from "react-icons/io";
import { FaLongArrowAltRight } from "react-icons/fa";


const services = [
    {
        title: "Study Permit",
        desc: "Enables international students to study at designated learning institutions in Canada. Applicants must show acceptance, financial support, and intent to return home after studies.",
        image: workImg,
        icon: workIcon,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada.html",
    },
    {
        title: "Work Permit ",
        desc: "Allows foreign nationals to work in Canada temporarily, either through employer-specific or open permits. Often linked to job offers or international agreements.",
        image: studyImg,
        icon: studyIcon,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/work-canada.html",
    },
    {
        title: "Visitor Visa",
        desc: "Grants short-term entry to Canada for tourism, family visits, or business. Applicants must prove ties to their home country and financial stability.",
        image: visitImg,
        icon: visitIcon,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada.html",
    },
    {
        title: "Refugees and asylum",
        desc: "Offered to individuals seeking protection in Canada due to fear of persecution, torture, or danger in their home country. ",
        image: visitImgw,
        icon: tourists,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/refugees.html",
    },
    {
        title: "RAD Appeal ",
        desc: "A legal avenue for asylum seekers to challenge a negative refugee decision through the Refugee Appeal Division.",
        image: visitImge,
        icon: migration1,
        link: "https://www.irb-cisr.gc.ca/en/refugee-appeals/pages/index.aspx",
    },
    {
        title: "Federal Appeal ",
        desc: "Permits individuals to appeal immigration-related decisions in Federal Court when legal or procedural errors are believed to have occurred.",
        image: visitImgs,
        icon: migration,
        link: "https://www.fca-caf.ca/en/home",
    },
    {
        title: "Humanitarian and Compassionate Grounds",
        desc: "A pathway for those without status in Canada to apply for permanent residency based on compelling personal, family, or hardship factors.",
        image: visitImgwd,
        icon: tourists,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/refugees/protection/refusal-options/humanitarian-compassionate-grounds.html",
    },
    {
        title: "Super Visa for Parents & GrandParents",
        desc: "A long-term multiple-entry visa for parents and grandparents of Canadian citizens or permanent residents, allowing stays of up to 5 years per visit. ",
        image: visitImge1,
        icon: migration1,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/parent-grandparent-super-visa.html",
    },
    {
        title: "Sponsor Your Family Members",
        desc: "Allows Canadian citizens and permanent residents to sponsor spouses, children, parents, and other eligible relatives to become permanent residents. ",
        image: studyImg1,
        icon: migration,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/family-sponsorship.html",
    },


    {
        title: "Citizenship ",
        desc: "Eligible permanent residents can apply for Canadian citizenship after meeting residency, language, and knowledge requirements.",
        image: visitImgs1,
        icon: tourists,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship.html",
    },

    {
        title: "Refugee Travel Document",
        desc: "Allows protected persons and refugees in Canada to obtain a travel document when they cannot get a passport from their home country, enabling them to travel internationally and return to Canada.",
        image: sponsorImg,
        icon: studyIcon,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/canadian-passports/travel-documents-non-canadians.html",
    },

    {
        title: "Permanent Residence from within Canada: Protected Persons and Convention Refugees",
        desc: "Allows protected persons and convention refugees already living in Canada to apply for permanent residence, giving them the opportunity to settle permanently and build a stable life in Canada.",
        image: residenceImg,
        icon: visitIcon,
        link: "https://www.canada.ca/en/immigration-refugees-citizenship/services/application/application-forms-guides/guide-5205-applying-permanent-residence-within-canada-protected-persons-convention-refugees.html",
    }


];




export default function VisaServices() {
    return (

        <>

            <section className="py-20 bg-[#eff2f5]">
                <div className="max-w-7xl mx-auto px-4">
                    {/* HEADING */}
                    <div className="text-center mb-14">
                        <p className="text-sm uppercase tracking-widest font-semibold text-gray-500 mb-3">
                            Trusted Support for Clients Across Multiple Provinces


                        </p>
                        <h2 className="text-3xl md:text-5xl pr-8 font-bold text-gray-900 capitalize leading-tight mb-4">
                            Immigration and File Management

                        </h2>
                        <p className="text-xl md:text-[19px] text-[#555555] leading-relaxed">
                            At Trinity Management Services, we offer comprehensive immigration and file management solutions for
                            individuals, families, and professionals. Our experienced team simplifies complex procedures and ensures
                            seamless coordination with trusted legal and immigration experts, delivering reliable support at every
                            stage of the process.

                        </p>
                        <div className="flex gap-2  justify-center my-6 md:my-6">
                            <div className="w-12 h-[3px] bg-[#ec4e4f]"></div>
                            <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                            <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                            <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                        </div>
                    </div>

                    {/* CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                        {services.map((item, index) => (
                            <div
                                key={index}
                                className="group bg-white shadow-md hover:shadow-xl transition-all duration-300 w-full h-full flex flex-col"
                            >
                                <div className="relative overflow-hidden">
                                    {/* IMAGE */}
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-110"
                                    />

                                    {/* RED OVERLAY SLIDE */}
                                    <div className="absolute inset-0 bg-red-500/70 
              transform scale-x-0 origin-left 
        transition-transform duration-500 
        group-hover:scale-x-100">
                                    </div>
                                </div>

                                {/* ICON IMAGE */}
                                <div className="flex justify-center -mt-8 relative z-[9]">
                                    <div className="bg-[#2f5885] w-16 h-16">
                                        <img
                                            src={item.icon}
                                            alt="icon"
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                </div>

                                {/* CONTENT */}
                                <div className="pt-3 text-center">
                                    <h3 className="text-[26px] font-[600] mb-3 px-6 line-clamp-1">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#555555] text-[15px] mb-6 px-6 line-clamp-3">
                                        {item.desc}
                                    </p>
                                    {/* READ MORE BUTTON */}
                                    <a
                                        target="_blank" rel="noopener noreferrer"
                                        href={item.link}
                                        className="group relative border-t border-[#e0e6ed] w-full py-5
                                    justify-center overflow-hidden inline-flex items-center gap-2
                                    font-medium text-[16px] mt-auto"
                                    >
                                        <span className="relative z-10 text-[#222] transition-colors duration-300 group-hover:text-white">
                                            Read More
                                        </span>

                                        <span className="relative z-10 transition-colors duration-300 group-hover:text-white">
                                            <IoIosArrowRoundForward className="text-[24px]" />
                                        </span>

                                        {/* Hover background */}
                                        <span className="absolute inset-0 bg-red-500 transform scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"></span>
                                    </a>


                                </div>
                            </div>
                        ))}
                    </div>



                </div>


                <div className="border-t  mt-12 ">
                    <div className="text-center max-w-7xl mx-auto px-4  text-[20px] flex justify-center flex-wrap pt-10 md:text-[26px] text-[#222222] cabin">
                        Your Trusted Partner in Immigration Success, at Trinity Management Services, we are committed to
                        guiding you confidently through every stage of your immigration journey.
                        <Link className="text-[#ec4e4f] font-semibold ml-2 hover:underline flex items-center gap-2" to="/contact-us" data-discover="true">Get In Touch <FaLongArrowAltRight />
                        </Link>
                    </div>
                </div>
            </section >
        </>
    )
}